import React from 'react';
import Navbar from './components/jsfiles/Navbar'
import Introduction from './components/jsfiles/Introduction'
import WelcomeSlide from './components/jsfiles/WelcomeSlide'
import Sixbuttondesign from './components/jsfiles/Sixbuttondesign'
import Dpi from './components/jsfiles/Dpi'
import Hardware from './components/jsfiles/Hardware'
import Battery from './components/jsfiles/Battery'
import Footer from './components/jsfiles/Footer'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  initClassName: 'aos-init', // class applied after initialization
  animatedClassName: 'aos-animate', // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
  

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 100, // values from 0 to 3000, with step 50ms
  duration: 2000, // values from 0 to 3000, with step 50ms
  easing: 'ease', // default easing for AOS animations
  once: false, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

});
function App() {
  return (
    <div className="App">
     <Navbar></Navbar>
     <WelcomeSlide></WelcomeSlide>
     <div >
     <Introduction></Introduction>
     </div>
    <div data-aos="fade-left">
    <Sixbuttondesign ></Sixbuttondesign>
    </div>
    <div data-aos="fade-right">
     <Dpi></Dpi>
     </div>
      <div data-aos="fade-left">
     <Hardware></Hardware>
     </div>
     <div data-aos="fade-right">
     <Battery ></Battery>
     </div>
     <Footer></Footer>
    
    </div>
  );
}

export default App;
